




















































































import IconButton from '@/components/Common/IconBtn.vue';
import TableComp from '@/components/Common/TableComp.vue';
import SearchGroup from '@/components/Common/SearchGroup.vue';
import CommonIconBtn from '@/components/Common/CommonIconBtn.vue'
import TableOperaBtn from '@/components/Common/TableOperaBtn.vue';
import { Component, Vue } from 'vue-property-decorator';
import { getDefaultRoleListApi, getGearUserListApi, deleteGearUserApi, enableGearUserApi } from '@/api/company';
import { debounce } from '@/utils/function_utils';

interface IReqFilter {
  keyword: string;
  typeKey: string;
}

@Component({
  name: 'contactPersonList',
  components: {
    TableComp,
    IconButton,
    SearchGroup,
    TableOperaBtn,
    CommonIconBtn,
  }
})
export default class extends Vue {

  public tableData: any = [];
  public typeKeyOptions: any = [];
  public reqFilter: IReqFilter = {
    keyword: '',
    typeKey: '',
  }

  // 利用防抖避免连续多次点击发送多次请求
  public getTables = debounce(this.getTableDatas, 500);

  public created() {
    this.getTables();
    this.getTypeKeyOptions();
  }

  public async getTypeKeyOptions() {
    const { data } = await getDefaultRoleListApi();
    this.typeKeyOptions = data.datas;
  }

  public async getTableDatas() {
    const { data } = await getGearUserListApi(this.reqFilter);
    this.tableData = data.datas;
  }

  public handleAdd() {
    this.$router.push({ name: 'contactPerson', params: { id: 'add' } });
  }

  public handleEdit(row: any) {
    const id = row.id;
    this.$router.push({ name: 'contactPerson', params: { id } });
  }

  public async handleDelete(row: any) {
    this.$confirm(this.$t('company.deleteContactConfirm') as string, '', {
      confirmButtonText: this.$t('common.confirm') as string,
      cancelButtonText: this.$t('common.cancel') as string,
      type: 'warning',
    }).then(async () => {
      const id = row.id;
      await deleteGearUserApi(id);
      this.$message.success(this.$t('message.deleteSuccess') as string);
      this.getTables();
    }).catch(() => {
      this.$message.info(this.$t('common.cancelled') as string);
    });
  }

  public async handleChangeSwitch(row: any) {
    const id = row.id;
    const isEnable = row.isActive;
    try {
      await enableGearUserApi({ id, isEnable });
      this.$message.success(this.$t('message.setSuccess') as string);
      this.getTables();
    } catch(err) {
      //
    }
  }

  public handleSearch() {
    this.getTables();
  }

  public handleReset() {
    this.reqFilter = {
      keyword: '',
      typeKey: '',
    }
    this.getTables();
  }

  public handleRefresh() {
    this.getTables();
  }
}
